// extracted by mini-css-extract-plugin
export default {"loader":"SpinnerButton_loader__Og2YO","relative":"SpinnerButton_relative__T42eh","hideText":"SpinnerButton_hideText__z2d0k"};